import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { VerfuegungFacade } from '@schir-int-client/verfuegung-shared';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class CreateLfprVerfuegungFormservice {
	private readonly facade = inject(VerfuegungFacade);
	private readonly aufgabeFormService = inject(CreateAufgabeFormService);

	readonly registerakteGroup = this.aufgabeFormService.form.controls.LFPR_REGISTERAKTE_ANLEGEN;
	readonly schuldtitelGroup = this.aufgabeFormService.form.controls.LFPR_SCHULDTITEL;
	readonly mittelungGroup = this.aufgabeFormService.form.controls.LFPR_MITTEILUNG;
	readonly statistikGroup = this.aufgabeFormService.form.controls.LFPR_STATISTIK;
	readonly verweisungsvermerkGroup = this.aufgabeFormService.form.controls.LFPR_VERWEISUNGSVERMERK;
	readonly dbAktualisierenGroup = this.aufgabeFormService.form.controls.LFPR_DB_AKTUALISIEREN;
	readonly blattabschriftGroup = this.aufgabeFormService.form.controls.LFPR_BLATTABSCHRIFT;
	readonly negativbescheinigungGroup = this.aufgabeFormService.form.controls.LFPR_NEGATIVBESCHEINIGUNG;
	readonly kostenGroup = this.aufgabeFormService.form.controls.LFPR_KOSTEN;
	readonly wiedervorlageGroup = this.aufgabeFormService.form.controls.LFPR_WIEDERVORLAGE;
	readonly erledigtGroup = this.aufgabeFormService.form.controls.LFPR_ERLEDIGT;
	readonly weglegenGroup = this.aufgabeFormService.form.controls.LFPR_WEGLEGEN;
	readonly sammlungGroup = this.aufgabeFormService.form.controls.LFPR_SAMMLUNG;
	readonly controlVerfuegungNotiz = new FormControl<string>(null);

	form = new FormGroup({ controlVerfuegungNotiz: this.controlVerfuegungNotiz });

	submit(): boolean {
		if (this.checkPreconditions()) {
			const creating = this.facade.createVerfuegungByVorgang(this.controlVerfuegungNotiz.value);
			if (this.isAnyAufgabeSelected()) {
				creating
					.pipe(
						filter(created => !created.loading),
						take(1)
					)
					.subscribe(() => this.aufgabeFormService.submit());
			}
			return true;
		}
		return false;
	}

	checkPreconditions(): boolean {
		return !this.isAnyAufgabeSelected() || this.aufgabeFormService.isValid();
	}

	private isAnyAufgabeSelected(): boolean {
		return (
			this.registerakteGroup.enabled ||
			this.schuldtitelGroup.enabled ||
			this.mittelungGroup.enabled ||
			this.statistikGroup.enabled ||
			this.verweisungsvermerkGroup.enabled ||
			this.dbAktualisierenGroup.enabled ||
			this.blattabschriftGroup.enabled ||
			this.negativbescheinigungGroup.enabled ||
			this.kostenGroup.enabled ||
			this.wiedervorlageGroup.enabled ||
			this.erledigtGroup.enabled ||
			this.sammlungGroup.enabled ||
			this.weglegenGroup.enabled
		);
	}
}
